import Cookies from "js-cookie";
const getAccessToken = () => {
  return Cookies.get("accessToken");
};

export const GET_PARAMS = token => {
  return {
    method: "GET",
    headers: {
      Authorization: `Bearer ${token || getAccessToken()}`
    }
  };
};

export const POST_PARAMS = body => ({
  method: "POST",
  headers: {
    Accept: "application/json",
    "Content-Type": "application/json",
    Authorization: `Bearer ${getAccessToken()}`
  },
  body: JSON.stringify(body)
});

export const PATCH_PARAMS = body => ({
  method: "PATCH",
  headers: {
    Accept: "application/json",
    "Content-Type": "application/json",
    Authorization: `Bearer ${getAccessToken()}`
  },
  body: JSON.stringify(body)
});

export const DELETE_PARAMS = {
  method: "DELETE",
  headers: {
    Authorization: `Bearer ${getAccessToken()}`
  }
};
